module.exports = __webpack_public_path__ + "static/memoji-f5028239503b77a73aa9019cb9a132fe.png";